import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRequestData, useLabels } from 'wsm-common-data';
import { ErrorBoundary } from 'wsm-error-boundary';

import Router from '../components/Router';
import ScrollToTop from '../components/ScrollToTop';
import BuilderRoutes from '../components/BuilderRoutes';
import Progress from '../components/Progress';
import VehicleCard from '../components/VehicleCard';
import NavButtons from '../components/NavButtons';
import SwipeableTray from '../components/SwipeableTray';
import stepController from '../controllers/StepController';
import { errorBoundaryHandler } from '../helpers/logging-client';
import { NR_LOGGING_ATTR_PREFIX } from '../constants';

import '../global-sass/main.scss';

const Widget = () => {
	const { deviceType } = useRequestData();
	const isDesktop = deviceType === 'DESKTOP';
	const labels = useLabels();

	const [currentStep, setCurrentStep] = useState('make');

	// keep in sync with redux
	stepController.updateSteps({
		state: useSelector((state) => state),
		currentStep,
		labels,
		isDesktop
	});
	const { rootDir } = useSelector((state) => state);

	const nextStepLink = stepController.getNextStep();
	const prevStepLink = stepController.getPreviousStep();
	const currentStepObj = stepController.getCurrentStepObj();
	const progressInfo = stepController.getProgressInfo();
	const rootPath = stepController.getRootPath();
	const { showVehicleCardClass, mainHeadingClass, stepHeadingClass } =
		stepController.getWidgetClasses();

	return (
		<ErrorBoundary
			errorHandler={errorBoundaryHandler}
			newRelicPageAction={`${NR_LOGGING_ATTR_PREFIX}-error-boundary`}
		>
			<Router>
				<ScrollToTop />
				<div className="text-center mb-4">
					<h1 className={`ddc-heading-1 ${mainHeadingClass}`}>
						{labels.get('BUILD_IT_FOR_ME')}
					</h1>
					<Progress {...progressInfo} />
					{currentStepObj.heading && (
						<p
							className={`font-weight-bold text-capitalize ${stepHeadingClass}`}
						>
							{labels.get(currentStepObj.heading)}
						</p>
					)}
					<div
						className={`d-flex justify-content-center mb-2 ${currentStepObj.flexClass}`}
					>
						<div
							style={
								!currentStepObj.showVehicleCard
									? { width: '100%' }
									: {}
							}
							className={
								currentStepObj.showVehicleCard
									? showVehicleCardClass
									: ''
							}
						>
							<BuilderRoutes
								{...{
									nextStepLink,
									setCurrentStep,
									rootDir
								}}
							/>
							<NavButtons
								{...{
									rootPath,
									currentStepObj,
									nextStepLink,
									prevStepLink
								}}
							/>
						</div>
						{stepController.showVehicleCard() && (
							<VehicleCard currentStep={currentStep} />
						)}
					</div>
				</div>
				{stepController.showTray() && (
					<div>
						<SwipeableTray
							overflowHeight={82}
							marginTop={0}
							currentStep={currentStep}
						/>
					</div>
				)}
			</Router>
		</ErrorBoundary>
	);
};

Widget.propTypes = {};

export default Widget;
